const INITIAL_STATE = {
	user: {
		dados: null,
		token: null,
		signed: false,
		loading: false,
		erro: null,
	},
	dev: {
		token: null,
		loading: false,
		erro: null,
	},
	authv1: {
		token: null,
		expires: null,
		loading: false,
		erro: null,
	},
};

// eslint-disable-next-line default-param-last
export function auth(state = INITIAL_STATE, action) {
	switch (action.type) {
		case '@auth/REQUEST_LOGIN':
			return {
				...state,
				user: { ...state.user, loading: true },
			};
		case '@auth/REQUEST_LOGIN_MASTER':
			return {
				...state,
				user: { ...state.user, loading: true },
			};
		case '@auth/SUCCESS_LOGIN':
			return {
				...state,
				user: {
					token: {
						access: action.payload.dados.access,
						refresh: action.payload.dados.refresh,
					},
					dados: action.payload.dados.dados,
					loading: false,
					erro: null,
					signed: true,
				},
			};

		case '@auth/FAILURE_LOGIN':
			return {
				...state,
				user: {
					dados: null,
					token: null,
					loading: false,
					erro: action.payload.erro,
					signed: false,
				},
				authv1: {
					token: null,
					expires: null,
					loading: false,
					erro: null,
				},
			};

		case '@auth/REQUEST_TOKEN_DEV':
			return {
				...state,
				dev: { ...state.dev, loading: true },
			};
		case '@auth/SUCCESS_TOKEN_DEV':
			return {
				...state,
				dev: {
					token: action.payload.token,
					loading: false,
					erro: null,
				},
			};
		case '@auth/FAILURE_TOKEN_DEV':
			return {
				...state,
				dev: { token: null, loading: false, erro: action.payload.erro },
			};

		case '@auth/SIGNOUT':
			return {
				...state,
				user: {
					dados: null,
					token: null,
					signed: false,
					loading: false,
					erro: null,
				},
				authv1: {
					token: null,
					expires: null,
					loading: false,
					erro: null,
				},
			};
		case '@auth/SUCCESS_TOKEN_V1':
			return {
				...state,
				authv1: {
					token: action.payload.dados.token,
					expires: action.payload.dados.expires,
					loading: false,
					erro: null,
				},
			};
		case '@auth/FAILED_TOKEN_V1':
			return {
				...state,
				authv1: {
					token: null,
					expires: null,
					loading: false,
					erro: null,
				},
			};
		default:
			return state;
	}
}
